import React, { useEffect, useState } from "react";
import { clockTime } from "./common";
import { fontClass } from "../boardSchema";

// 24-hour by default; config.timeFormat "12h" for a 12-hour clock. (The old
// `hour12` flag is ignored: it was on by default, not by choice.)
const ClockWidget = ({ config = {} }) => {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const dateOpts = { weekday: "long", month: "long", day: "numeric" };
  if (config.tz) dateOpts.timeZone = config.tz;

  return (
    <div className={`sb-card sb-clock${fontClass(config.font)}`}>
      <div className="sb-clock-time">{clockTime(now, { timeFormat: config.timeFormat, tz: config.tz })}</div>
      {config.showDate !== false && (
        <div className="sb-clock-date">{now.toLocaleDateString([], dateOpts)}</div>
      )}
    </div>
  );
};

export default ClockWidget;
